// extracted by mini-css-extract-plugin
export default {"heading3":"heading3--uy7JP"};